<template>
  <div class="form-field-group clearfix">
    <div v-if="to.wrapper === 'panel'" class="card mb-3">
      <div class="card-header" :class="{ 'cursor-pointer': to.collapsible }" @click="toggle">
        {{ to.title }}
        <small v-if="to.help && !collapsed"><br>{{ to.help }}</small>
        <span v-if="to.collapsible" class="float-right">{{ collapsed ? '▸' : '▾' }}</span>
      </div>
      <div v-show="!collapsed" class="card-body">
        <div class="card-text">
          <former-form
            :model="model[field.key]"
            :form="form"
            :formerfields="field.fields"
            :class="field.className"
          />
        </div>
      </div>
    </div>
    <div v-if="to.wrapper !== 'panel'" class="clearfix">
      <h5 v-if="to.title">{{ to.title }}</h5>
      <former-form :model="model[field.key]" :form="form" :formerfields="field.fields"></former-form>
    </div>
  </div>
</template>

<script>
import baseField from './baseField'
export default {
  name: 'formerGroup',
  mixins: [baseField],
  data () {
    return {
      collapsed: this.field.templateOptions && this.field.templateOptions.collapsed === true
    }
  },
  created () {
    if (this.model[this.field.key] === '') {
      this.model[this.field.key] = {}
    }
  },
  methods: {
    toggle () {
      if (this.to.collapsible) this.collapsed = !this.collapsed
    }
  }
}
</script>
